import React, { Component } from 'react'
import util from '../../util'
import debug from 'debug'
import { DayPickerContainer } from './index'
import { connect } from 'react-redux'
import { removeHotelBookingDateRange } from '../../redux/slices'
import getTime from 'date-fns/getTime'

const log = debug('carla:search')

class DateRangePicker extends Component {
  state = {
    today: util.normalizeDate(new Date()),
    hovered: null, // current date with mouse over (Date)
    firstMonth: null // first month calendar is showing (Date)
  }

  constructor(props) {
    super(props)
    this.state.firstMonth = props.pickupDate
  }

  handleDayClick = (day) => {
    util.normalizeDate(day)
    const { startDate, endDate } = this.props
    const pickupDate = startDate ? new Date(startDate) : null
    const dropOffDate = endDate ? new Date(endDate) : null

    const { today } = this.state
    if (day < today) {
      return
    }

    let newPickupDate, newDropOffDate // new cells on calendar

    if (!pickupDate && !dropOffDate) {
      // start selection
      newPickupDate = day
      newDropOffDate = day
      log(`starting new range selection from: ${newPickupDate}`)
    } else if (pickupDate && dropOffDate) {
      // restart selection
      if (pickupDate.getTime() === dropOffDate.getTime()) {
        // if single date is selected
        if (day.getTime() === pickupDate.getTime()) {
          // if pickup date clicked again
          newPickupDate = null
          newDropOffDate = null
          log(`pickup date clicked again, clearing`)
        } else if (day > dropOffDate) {
          newPickupDate = pickupDate
          newDropOffDate = day
          log(`selection complete, drop off date ${newPickupDate}`)
        } else if (day < pickupDate) {
          newPickupDate = day
          newDropOffDate = day
          log(`restarting selection starting from ${newPickupDate}`)
        }
      } else {
        // if a range is selected
        if (day.getTime() === pickupDate.getTime()) {
          // if pickup date clicked again
          newPickupDate = null
          newDropOffDate = null
          log(`pickup date clicked again, clearing`)
        } else {
          newPickupDate = day
          newDropOffDate = day
          log(`restarting selection from: ${newPickupDate}`)
        }
      }
    } else {
      console.error('wtf')
    }

    // TODO: refactor
    newPickupDate.setHours(12)
    newPickupDate.setMinutes(0)
    newDropOffDate.setHours(12)
    newDropOffDate.setMinutes(0)
    if (newPickupDate && newDropOffDate) {
      this.props.onChange({
        startDate: getTime(newPickupDate),
        endDate: getTime(newDropOffDate)
      })
    } else {
      this.props.removeHotelBookingDateRange()
    }
  }

  handleDayMouseEnter = (day) => {
    if (this.props.startDate && this.props.endDate) {
      this.setState({ hovered: null })
    } else {
      this.setState({ hovered: day })
    }
  }

  handleDayMouseLeave = () => this.setState({ hovered: null })

  render() {
    // date pickers
    const { startDate, endDate } = this.props
    const pickupDate = startDate ? new Date(startDate) : null
    const dropOffDate = endDate ? new Date(endDate) : null

    const { hovered, today, firstMonth } = this.state
    const disabledDays = { before: today }

    const selectedDays = {
      from: pickupDate,
      to: dropOffDate
    }
    const modifiers = {
      start: pickupDate,
      end: dropOffDate
    }

    if (
      pickupDate &&
      dropOffDate &&
      pickupDate.getTime() === dropOffDate.getTime() && // only single day selected currently
      hovered > pickupDate // hovered day is after pickup date
    ) {
      modifiers.selecting = {
        from: pickupDate,
        to: hovered
      }
      modifiers.end = hovered
    }

    return (
      <DayPickerContainer
        {...this.props}
        numberOfMonths={2}
        fromMonth={today}
        month={firstMonth}
        disabledDays={disabledDays}
        selectedDays={selectedDays}
        modifiers={modifiers}
        onDayMouseEnter={this.handleDayMouseEnter}
        onDayMouseLeave={this.handleDayMouseLeave}
        onDayClick={this.handleDayClick}
      />
    )
  }
}

export default connect((state) => ({}), { removeHotelBookingDateRange })(DateRangePicker)
